import React from "react";
import { useStyles } from "./AssetNonTitled/AssetNonTitledFormStyles";
import { Box, Grid, Typography } from "@material-ui/core";
import Utils from "../Utils";

const PriceDigest = ({ detail }) => {
	const classes = useStyles();

	return (
		<Box>
			<Grid container spacing={1} style={{ padding: "8px" }}>
				<Grid container item justifyContent="space-between">
					<Typography variant="body1" gutterBottom>
						{detail.type === "Non-Titled" ? "Fair Market" : "Retail"}
					</Typography>

					<Typography variant="body1">
						{"$" + Utils.formatCurrencyNumber(detail.retailValue)}
					</Typography>
				</Grid>
				<Grid container item justifyContent="space-between" className={classes.pdrowItem}>
					<Typography variant="body1" gutterBottom>
						{detail.type === "Non-Titled" ? "Orderly Liq" : "Wholesale"}
					</Typography>

					<Typography variant="body1">
						{"$" + Utils.formatCurrencyNumber(detail.wholesaleValue)}
					</Typography>
				</Grid>
				<Grid container item justifyContent="space-between" className={classes.pdrowItem}>
					<Typography variant="body1" gutterBottom>
						{detail.type === "Non-Titled" ? "Forced Liq" : "Finance"}
					</Typography>

					<Typography variant="body1">
						{"$" + Utils.formatCurrencyNumber(detail.financeValue)}
					</Typography>
				</Grid>
				<Grid container item justifyContent="space-between" className={classes.pdrowItem}>
					<Typography variant="body1" gutterBottom>
						{detail.type === "Non-Titled" ? "Forced Liq" : "NMEF"}
					</Typography>

					<Typography variant="body1">
						{"$" + Utils.formatCurrencyNumber(detail.nmefValue)}
					</Typography>
				</Grid>
			</Grid>
		</Box>
	);
};
export default PriceDigest;
